<div class="container-fluid">

  <div class="container">

    <app-alert-messages [maximumNumberOfMessages]="1"></app-alert-messages>

    <div class="row mt-5">

      <h1 class="display-5">Forfaits Mensuels Optitax <span class="badge text-bg-success">Inclus les calculs fiscaux avancés</span>
    </h1>

    <div class="col-12 col-lg-8">
      <div class="row">


        <div class="col-12 col-lg-6">
          <label id="license_individual">
            <input [formControl]="this.getLicenseTypeFormControl()" class="card-input-element" type="radio"
              value="INDIVIDUAL">
            <div class="card card-input mb-3">
              <div class="text-center mb-4 mt-4">
                <h2 class="mt-2 mb-4 display-1">89$
                  <small>/mois</small>
                </h2>

                <div class="text-center" style="min-height: 22.5px;">
                  @if (currentLicenseState === 'LOADING' || currentLicenseState === 'REFRESHING') {
                    <div>
                      <span class="spinner-border spinner-border-sm me-3" role="status"></span>
                    </div>
                  }
                  @if (currentLicense === 'INDIVIDUAL') {
                    <span class="badge text-bg-primary">Forfait actuel</span>
                  }
                </div>

                <h3 class="mt-3 h2">1 utilisateur</h3>
                <p class="card-text text-secondary">Pour les comptables indépendants</p>


              </div>

              <div class="card-body">
                <!--                            <h6 class="text-uppercase text-center text-muted my-4">-->
                <!--                                1 utilisateur-->
              <!--                            </h6>-->

              <!--                            &lt;!&ndash; Price &ndash;&gt;-->
              <!--                            <div class="row g-0 align-items-center justify-content-center">-->
              <!--                                <div class="col-auto">-->
              <!--                                    <div class="h2 mb-0">89$</div>-->
            <!--                                </div>-->
          <!--                            </div> &lt;!&ndash; / .row &ndash;&gt;-->

          <!--                            &lt;!&ndash; Period &ndash;&gt;-->
          <!--                            <div class="h6 text-uppercase text-center text-muted mb-5">-->
          <!--                                / mois-->
        <!--                            </div>-->

        <ul class="list-unstyled ms-4">

          <li class="mb-1 text-secondary"><i class="fad fa-check-circle"
          style="--fa-primary-color: #1C7ED6; --fa-secondary-color:#D2DDEC;"></i>
          1 utilisateur
        </li>
        <li class="mb-1 text-secondary"><i class="fad fa-check-circle"
        style="--fa-primary-color: #1C7ED6; --fa-secondary-color:#D2DDEC;"></i>
        Accès à tous les calculs
      </li>
      <li class="mb-1 text-secondary"><i class="fad fa-check-circle"
      style="--fa-primary-color: #1C7ED6; --fa-secondary-color:#D2DDEC;"></i>
      Accès au portail client
    </li>

    <li class="mb-1 text-secondary"><i class="fad fa-check-circle"
    style="--fa-primary-color: #1C7ED6; --fa-secondary-color:#D2DDEC;"></i>
    Nombre illimité de clients
  </li>
  <li class="mb-1 text-secondary"><i class="fad fa-check-circle"
  style="--fa-primary-color: #1C7ED6; --fa-secondary-color:#D2DDEC;"></i>
  Nombre illimité de questionnaires
</li>
<li class="mb-1 text-secondary"><i class="fad fa-check-circle"
style="--fa-primary-color: #1C7ED6; --fa-secondary-color:#D2DDEC;"></i>
Accès aux questionnaires de récolte d'information client
</li>
<li class="mb-1 text-secondary"><i class="fad fa-check-circle"
style="--fa-primary-color: #1C7ED6; --fa-secondary-color:#D2DDEC;"></i>
Support par clavardage
</li>

</ul>

<div class="d-flex align-items-center justify-content-center mt-5">
  <span> <i class="fas fa-check-circle"></i> </span>
</div>

</div>

</div>
</label>
</div>

<div class="col-12 col-lg-6">
  <label id="license_team">
    <input [formControl]="this.getLicenseTypeFormControl()" class="card-input-element" type="radio"
      value="TEAM">
    <div class="card card-input mb-3">
      <div class="text-center mb-4 mt-4">
        <h2 class="mt-2 mb-4 display-1">199$
          <small>/mois</small>
        </h2>

        <div class="text-center" style="min-height: 22.5px;">
          @if (currentLicenseState === 'LOADING' || currentLicenseState === 'REFRESHING') {
            <div>
              <span class="spinner-border spinner-border-sm me-3" role="status"></span>
            </div>
          }
          @if (currentLicense === 'TEAM') {
            <span
            class="badge text-bg-primary">Forfait actuel</span>
          }
        </div>

        <h3 class="mt-3 h2">25 utilisateurs</h3>
        <p class="card-text text-secondary">Pour les cabinets comptables</p>
      </div>

      <div class="card-body">
        <!--                            <h6 class="text-uppercase text-center text-muted my-4">-->
        <!--                                1 utilisateur-->
      <!--                            </h6>-->

      <!--                            &lt;!&ndash; Price &ndash;&gt;-->
      <!--                            <div class="row g-0 align-items-center justify-content-center">-->
      <!--                                <div class="col-auto">-->
      <!--                                    <div class="h2 mb-0">89$</div>-->
    <!--                                </div>-->
  <!--                            </div> &lt;!&ndash; / .row &ndash;&gt;-->

  <!--                            &lt;!&ndash; Period &ndash;&gt;-->
  <!--                            <div class="h6 text-uppercase text-center text-muted mb-5">-->
  <!--                                / mois-->
<!--                            </div>-->

<ul class="list-unstyled ms-4">

  <li class="mb-1 text-secondary"><i class="fad fa-check-circle"
  style="--fa-primary-color: #1C7ED6; --fa-secondary-color:#D2DDEC;"></i>
  25 utilisateurs
</li>
<li class="mb-1 text-secondary"><i class="fad fa-check-circle"
style="--fa-primary-color: #1C7ED6; --fa-secondary-color:#D2DDEC;"></i>
Accès à tous les calculs
</li>
<li class="mb-1 text-secondary"><i class="fad fa-check-circle"
style="--fa-primary-color: #1C7ED6; --fa-secondary-color:#D2DDEC;"></i>
Accès au portail client
</li>
<li class="mb-1 text-secondary"><i class="fad fa-check-circle"
style="--fa-primary-color: #1C7ED6; --fa-secondary-color:#D2DDEC;"></i>
Nombre illimité de clients
</li>
<li class="mb-1 text-secondary"><i class="fad fa-check-circle"
style="--fa-primary-color: #1C7ED6; --fa-secondary-color:#D2DDEC;"></i>
Nombre illimité de questionnaires
</li>
<li class="mb-1 text-secondary"><i class="fad fa-check-circle"
style="--fa-primary-color: #1C7ED6; --fa-secondary-color:#D2DDEC;"></i>
Accès aux questionnaires de récolte d'information client
</li>
<li class="mb-1 text-secondary"><i class="fad fa-check-circle"
style="--fa-primary-color: #1C7ED6; --fa-secondary-color:#D2DDEC;"></i>
Support par clavardage
</li>

</ul>

<div class="d-flex align-items-center justify-content-center mt-5">
  <span> <i class="fas fa-check-circle"></i> </span>
</div>
</div>

</div>
</label>
</div>

<div class="col-12">
  <h1 class="display-5 mt-3">Forfait Annuel Questionnaire + Portail Client <br><small>(Sans les
  calculs fiscaux avancés)</small></h1>
  <label class="d-block" id="license_questionnaire">
    <input [formControl]="this.getLicenseTypeFormControl()" class="card-input-element" type="radio"
      value="QUESTIONNAIRE">
    <div class="card card-input mb-3">
      <div class="text-center mb-4 mt-4">
        <h2 class="mt-2 mb-4 display-1"><s class="text-danger">499$</s> 99$
        <small>/année</small>
      </h2>


      <h3 class="mt-3 h2">Questionnaires de prise d'information fiscale</h3>
      <p class="card-text text-secondary">Inclus un nombre illimité de questionnaires et
      clients</p>
    </div>

    <div class="card-body">
      <!--                            <h6 class="text-uppercase text-center text-muted my-4">-->
      <!--                                1 utilisateur-->
    <!--                            </h6>-->

    <!--                            &lt;!&ndash; Price &ndash;&gt;-->
    <!--                            <div class="row g-0 align-items-center justify-content-center">-->
    <!--                                <div class="col-auto">-->
    <!--                                    <div class="h2 mb-0">89$</div>-->
  <!--                                </div>-->
<!--                            </div> &lt;!&ndash; / .row &ndash;&gt;-->

<!--                            &lt;!&ndash; Period &ndash;&gt;-->
<!--                            <div class="h6 text-uppercase text-center text-muted mb-5">-->
<!--                                / mois-->
<!--                            </div>-->

<ul class="list-unstyled ms-4">
  <li class="mb-1 text-secondary"><i class="fad fa-check-circle"
  style="--fa-primary-color: #1C7ED6; --fa-secondary-color:#D2DDEC;"></i>
  Nombre illimités de clients
</li>
<li class="mb-1 text-secondary"><i class="fad fa-check-circle"
style="--fa-primary-color: #1C7ED6; --fa-secondary-color:#D2DDEC;"></i>
Nombre illimités de questionnaires
</li>
<li class="mb-1 text-secondary"><i class="fad fa-check-circle"
style="--fa-primary-color: #1C7ED6; --fa-secondary-color:#D2DDEC;"></i>
Accès au portail client
</li>
<li class="mb-1 text-secondary"><i class="fad fa-check-circle"
style="--fa-primary-color: #1C7ED6; --fa-secondary-color:#D2DDEC;"></i>
Accès aux questionnaires de récolte d'information client
</li>
<li class="mb-1 text-secondary"><i class="fad fa-check-circle"
style="--fa-primary-color: #1C7ED6; --fa-secondary-color:#D2DDEC;"></i>
Support par clavardage
</li>

</ul>

<div class="d-flex align-items-center justify-content-center mt-5">
  <span> <i class="fas fa-check-circle"></i> </span>
</div>
</div>

</div>
</label>
</div>
</div>
</div>
<div class="col-12 col-lg-4 bg-primary-soft p-5 rounded">
  <h4>Résumé de l'abonnement</h4>
  <ul class="list-group list-group-flush">
    <li class="list-group-item d-flex align-items-center justify-content-between px-0 pb-5">
      <div><h5>Forfait @if (this.billingCycle === 'MONTHLY') {
        <span>mensuel</span>
        }@if (this.billingCycle === 'YEARLY') {
        <span
        >annuel</span>
      }</h5>
      @if (amountState === 'LOADING' || amountState === 'REFRESHING') {
        <span><span
        class="spinner-border spinner-border-sm me-3" role="status"></span></span>
      }
      @if (this.getLicenseTypeFormControl().value === 'TEAM') {
        <span>25 utilisateurs</span>
      }
      @if (this.getLicenseTypeFormControl().value === 'INDIVIDUAL') {
        <span>1 utilisateur</span>
      }
      @if (this.getLicenseTypeFormControl().value === 'QUESTIONNAIRE') {
        <span>Questionnaire + Portail utilisateur (sans les calculs)</span>
      }
    </div>
    @if (amountState === 'LOADING' || amountState === 'REFRESHING') {
      <div>
        <span class="spinner-border spinner-border-sm me-3" role="status"></span>
      </div>
    }
    @if (amountState === 'READY') {
      <div>{{ subtotal | number:'1.2':'fr-CA' }} $ <br><small
      class="text-gray-700">(taxes en sus)</small></div>
    }
  </li>
</ul>
<br>
  <div class="d-flex mb-4">
    <div class="p-2 flex-grow-1"><h4>Carte de crédit</h4></div>
    <div>
      <button (click)="showAddPaymentMethodModal()" class="btn btn-sm btn-primary"><i
      class="fa fa-credit-card"></i> Ajouter
    </button>
  </div>
</div>

<div class="dropdown d-grid text-left">
  <button aria-expanded="false" class="text-left dropdown-toggle btn btn-white p-3"
    data-bs-toggle="dropdown" style="text-align: left;"
    type="button">
    @if (paymentMethodState === 'LOADING' || paymentMethodState === 'REFRESHING') {
      <span
        class="d-inline-block"
        style="width: 90%;">
        <span class="spinner-border spinner-border-sm me-3" role="status"></span>
        Chargement...
      </span>
    }

    @if (paymentMethodState === 'READY' && paymentMethods.length === 0) {
      <span class="d-inline-block"
        style="width: 90%;">
        Vous devez ajouter une carte de crédit
      </span>
    }

    @if (paymentMethodState === 'READY' && selectedPaymentMethod !== undefined) {
      <app-credit-card-row
        [paymentMethod]="this.selectedPaymentMethod"
        class="d-inline-block"
      style="width: 95%;"></app-credit-card-row>
    }
  </button>
  <div class="dropdown-menu" style="width: 100%;">
    @for (paymentMethod of paymentMethods; track paymentMethod) {
      <button (click)="selectPaymentMethod(paymentMethod)"
        [class.bg-primary]="paymentMethod.id == selectedPaymentMethod.id" class="dropdown-item"
        class="dropdown-item" tabindex="0">
        <app-credit-card-row [paymentMethod]="paymentMethod"></app-credit-card-row>
      </button>
    }
  </div>
</div>

<p class="mt-4">En vous abonnant, vous acceptez les <a href="https://optitax.ca/conditions-utilisation">conditions
d'utilisation</a> d'Optitax.</p>

<div class="d-grid gap-2">
  <button (click)="submit()" class="btn btn-primary" id="start-free-trial-btn" type="button">Mettre à
    jour votre abonnement
  </button>
</div>
</div>
</div>

</div>
</div>

